const createSelectors = parentReducer => {
    return new class {
        selectQualifications = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["UserManagerAddUserWidget_reducer"];
            return reducer.qualifications;
        };
    }();
};

export default createSelectors;
